<template>
  <div class="text-style-selector" ref="selector">
    <div class="main-box">
      <div class="font-size-btn" @click="handleFontSizeClick">
        <div class="text">{{ selectedFontSize }}</div>
        <div :class="{ selected: showFontSizePopup }">
          <img src="../../assets/images/arrow-solid.png" alt="" />
        </div>
      </div>
      <div
        class="color-btn"
        @click="handleColorClick"
        :class="{ selected: showColorPopup }"
      >
        <div class="color-text">A</div>
        <div
          class="line"
          :style="{
            background: selectedColor,
          }"
        ></div>
        <!-- <img src="../../assets/images/text-a.png" alt="" /> -->
      </div>
    </div>
    <div v-if="showFontSizePopup" class="popup font-size-popup">
      <div class="popup-title">字号大小</div>
      <div class="font-size-list">
        <span
          v-for="size in fontSizes"
          :key="size"
          :class="['font-size-item', { active: selectedFontSize === size }]"
          @click="handleSelectFontSize(size)"
          >{{ size }}</span
        >
      </div>
    </div>
    <div v-if="showColorPopup" class="popup color-popup">
      <div class="popup-title">文字颜色</div>
      <div class="color-list">
        <span
          v-for="color in colors"
          :key="color"
          :class="['color-dot', { selected: selectedColor === color }]"
          :style="
            selectedColor === color
              ? { borderColor: color, background: 'transparent' }
              : { background: color, borderColor: 'transparent' }
          "
          @click="handleSelectColor(color)"
        >
          <span
            v-if="selectedColor === color"
            class="color-dot-inner"
            :style="{ background: color }"
          ></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "TextStyleSelector",
  props: {
    element: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    element: {
      handler(val) {
        if (val) {
          const data = this.whiteBoardService.getElementById(val.elementId);
          let fillColor = data.style.fillColor;
          if (/^rgba?\(/i.test(fillColor)) {
            this.selectedColor = this.rgbaToHex(fillColor);
          } else {
            this.selectedColor = fillColor;
          }
          const sizeMap = this.whiteBoardService.textSizeMap;
          const size = data.textSize;
          for (var key in sizeMap) {
            if (sizeMap[key] === size) {
              this.selectedFontSize = key;
            }
          }
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("live", ["whiteBoardService"]),
  },
  data() {
    return {
      fontSizes: [14, 16, 18, 20],
      colors: [
        "#000000",
        "#E2584F",
        "#F6C847",
        "#65C445",
        "#456FF6",
        "#7640EC",
      ],
      selectedFontSize: 14,
      selectedColor: "#000000",
      showFontSizePopup: false,
      showColorPopup: false,
    };
  },
  methods: {
    rgbaToHex(rgba) {
      const result = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (!result) return "#cccccc";
      const r = parseInt(result[1]).toString(16).padStart(2, "0");
      const g = parseInt(result[2]).toString(16).padStart(2, "0");
      const b = parseInt(result[3]).toString(16).padStart(2, "0");
      return `#${r}${g}${b}`.toUpperCase();
    },
    handleFontSizeClick() {
      this.showFontSizePopup = !this.showFontSizePopup;
      this.showColorPopup = false;
    },
    handleColorClick() {
      this.showColorPopup = !this.showColorPopup;
      this.showFontSizePopup = false;
    },
    handleSelectFontSize(size) {
      this.selectedFontSize = size;
      this.showFontSizePopup = false;
      this.$emit("change", {
        type: "size",
        value: size,
      });
    },
    handleSelectColor(color) {
      this.selectedColor = color;
      this.showColorPopup = false;
      this.$emit("change", {
        type: "color",
        value: color,
      });
    },
    handleClickOutside(e) {
      if (!this.$refs.selector.contains(e.target)) {
        this.showFontSizePopup = false;
        this.showColorPopup = false;
      }
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped>
.text-style-selector {
  position: relative;
  display: inline-block;
  .main-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px dashed #d8d8d8;
    padding: 2px 8px;
    width: 80px;
    height: 38px;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #e5e6eb;
    .font-size-btn,
    .color-btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-size: 16px;
      position: relative;
      &.selected {
        background: #e5e6eb;
      }
      .line {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
      }
    }
    .font-size-btn {
      font-weight: 500;
      font-size: 14px;
      color: #1d2129;
      line-height: 20px;
      img {
        width: 18px;
        height: 18px;
      }
      .text {
        width: 18px;
        height: 20px;
        line-height: 20px;
        text-align: center;
      }
      .selected {
        background: #e5e6eb;
      }
    }
    .color-btn {
      img {
        width: 20px;
        height: 20px;
      }
    }
    .color-dot {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      border: 4px solid #e0e0e0;
      margin-right: 4px;
      vertical-align: middle;
    }
  }
  .popup {
    position: absolute;
    top: 40px;
    left: 0;
    min-width: 167px;
    padding: 12px;
    z-index: 100;
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(20, 20, 43, 0.04);
    border-radius: 10px;
    border: 1px solid #e5e6eb;
    .popup-title {
      font-weight: 500;
      font-size: 12px;
      color: #4e5969;
      line-height: 20px;
      margin-bottom: 12px;
    }
    .font-size-list {
      display: flex;
      gap: 0 27px;
      .font-size-item {
        font-weight: 500;
        font-size: 14px;
        color: #1d2129;
        line-height: 20px;
        cursor: pointer;
        border-radius: 6px;
        &.active {
          // background: #f5f5f5;
          // color: #3d5afe;
          // font-weight: bold;
        }
      }
    }
    .color-list {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      gap: 18px 40px;
      padding: 0;
      .color-dot {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 3px solid transparent;
        display: inline-block;
        cursor: pointer;
        margin: 0;
        position: relative;
        transition: border-color 0.2s, background 0.2s;
        &.selected {
          background: transparent !important;
          border-width: 3px;
        }
        .color-dot-inner {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          transform: translate(-50%, -50%);
          background: inherit;
        }
      }
    }
  }
}
</style>
